const mapLabelToOption = label => ({ value: label, label })

const recommendBounceLabels = [
  'No OTP',
  'Mechanical Issues',
  'Unconfirmed VIN',
  'Not Tracking',
  'Dishonesty',
  'Unresponsive',
]

export const recommendBounceReasons = recommendBounceLabels.map(mapLabelToOption)
